import { tsrContractsClient } from '../tsrContractsClient';

export const clinicsContractClient = () => tsrContractsClient.clinicContract;
